module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/qa/male_specialist-207f3ce16dc42d5b38c3f250e98e5b75.png";